import { render, staticRenderFns } from "./AboutObject.vue?vue&type=template&id=161219fe&"
import script from "./AboutObject.vue?vue&type=script&lang=js&"
export * from "./AboutObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports